import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Components
// @ts-ignore
import GroupName from 'components/GroupName';
// @ts-ignore
import GroupNameLink from 'components/GroupNameLink';

// Selectors
// @ts-ignore
import { makeSelectPersonGroupIds } from 'services/groupPeople/selectors';
import RoleGate from 'components/RoleGate';
import { ADMIN, PAYROLL } from 'components/RoleGate/constants';

interface OwnProps {
    personId: number;
}

interface ConnectedProps {
    groupIds?: number[];
}

type Props = OwnProps & ConnectedProps;

export class PeopleGroupsList extends React.PureComponent<Props> {
    render(): React.ReactElement[] | null {
        const { groupIds } = this.props;

        if (!groupIds || !groupIds.length) return null;

        return groupIds.map((id, index) => (
            <span key={id}>
                {!!index && ', '}
                <RoleGate
                    requiredRoles={[ADMIN, PAYROLL]}
                    fallback={<GroupName groupId={id} />}
                >
                    <GroupNameLink groupId={id} />
                </RoleGate>
            </span>
        ));
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    groupIds: makeSelectPersonGroupIds()
});

export default connect(mapStateToProps)(PeopleGroupsList);
